import { DatePipe } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { SelectOption } from "src/app/models/common/select-option";
import { FormsService, Question } from "src/app/services/settings/forms.service";
import { AsyncModalService } from "src/app/services/shared/async-modal-service";
import { Globals } from "../../../app.globals";
import { LookupValuesService } from "../../../services/settings/lookupvalues.service";
import {
    QRCodeQuestion,
    QRCodeSetup,
    QRCodeTypes,
    QRCodeRoleDetail,
    QRCodeRoleAccessType,
    QRCodeTypeDetail,
    AccessTypes,
    QRCodeService
} from "../../../services/settings/qrcode.service";

@Component({
    standalone: false,
    selector: "app-qrcode-form",
    templateUrl: "./qrcode.form.component.html",
    styleUrls: ["./qrcode.form.component.css"],
    providers: [LookupValuesService]
})
export class QRCodeForm implements OnChanges {
    @ViewChild("closeQRCodeSetupButton") closeQRCodeSetupButton: ElementRef
    @ViewChild("inputSpinner", { read: ElementRef, static: false }) inputSpinner: ElementRef;

    @Output("onSaveQRCodeSetting") onSaveQRCodeSetting: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output("onCloseQRCodeSetting") onCloseQRCodeSetting: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() qrCodeFormQuestions: Question[];
    @Input("qrCodeSetup") qrCodeSetup: QRCodeSetup;
    @Input("isViewMode") isViewMode: boolean;
    @Input("isEditMode") isEditMode: boolean;
    @Input("isDisplayEntry") isDisplayEntry: boolean;
    @Input("isAllowUploadedCSV") isAllowUploadedCSV: boolean;

    faInfoSign = faInfoCircle;

    qrCodeSetupForm: FormGroup;

    typeOptions: SelectOption[] = [];
    accessTypeOptions: SelectOption[] = [];
    statusOptions: SelectOption[] = [];
    roleAccessTypeOptions: SelectOption[] = [];
    qrCodeFormQuesOptions: Question[];
    selectedPopulate1FormQuesRegister: Question[];
    selectedPopulate2FormQuesRegister: Question[];
    selectedPopulate3FormQuesRegister: Question[];
    selectedPopulate4FormQuesRegister: Question[];
    qrCodeFormQuesRegisterCol: any[];
    selectedPopulate1FormQuestionId: number[];
    selectedPopulate2FormQuestionId: number[];
    selectedPopulate3FormQuestionId: number[];
    selectedPopulate4FormQuestionId: number[];

    itemListGeneral = [];

    createRoleSelectedItems = [];
    updateRoleSelectedItems = [];
    populate1RoleSelectedItems: [] = [];
    populate2RoleSelectedItems: [] = [];
    populate3RoleSelectedItems: [] = [];
    populate4RoleSelectedItems: [] = [];
    viewRoleSelectedItems = [];

    formId: number;
    createAccordionOpened: boolean = false;
    updateAccordionOpened: boolean = false;
    populate1AccordionOpened: boolean = false;
    populate2AccordionOpened: boolean = false;
    populate3AccordionOpened: boolean = false;
    populate4AccordionOpened: boolean = false;
    viewAccordionOpened: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private asyncModalService: AsyncModalService,
        private lookupValuesService: LookupValuesService,
        private changeDetector: ChangeDetectorRef,
        private qrCodeService: QRCodeService,
        private formService: FormsService,
        private globals: Globals
    ) {

    }

    //#region hook methods

    async ngOnInit() {
        this.globals.showSpinner();
        this.formId = 0;
        this.selectedPopulate1FormQuestionId = [];
        this.selectedPopulate2FormQuestionId = [];
        this.selectedPopulate3FormQuestionId = [];
        this.selectedPopulate4FormQuestionId = [];
        this.selectedPopulate1FormQuesRegister = [];
        this.selectedPopulate2FormQuesRegister = [];
        this.selectedPopulate3FormQuesRegister = [];
        this.selectedPopulate4FormQuesRegister = [];

        this.setFormId();

        this.typeOptions = [
            { label: "View", value: "View" }
        ];

        this.accessTypeOptions = [
            { label: "Public", value: "Public" },
            { label: "Private", value: "Private" }
        ];

        this.statusOptions = [
            { label: "Active", value: true },
            { label: "Inactive", value: false }
        ];

        this.roleAccessTypeOptions = [
            { label: "Role Based", value: "RoleBased" },
            { label: "Non Role Based", value: "NonRoleBased" }
        ];

        this.qrCodeFormQuesRegisterCol = [
            { field: 'id', header: 'Id', visible: false },
            { field: 'label', header: 'Question' },
            { field: 'type', header: 'Value' }
        ];

        if (!this.qrCodeSetup)
            this.qrCodeSetup = new QRCodeSetup();
        //bind form controls
        this.bindFormControls();
        //bind form question dynamic controls 
        this.bindFormQuestionControlValidations();
        // bind role

        await this.roleBind();
        if (this.qrCodeSetup.id == 0 && !this.isEditMode && !this.isViewMode) {
            this.qrCodeSetup.qrCodeTypeDetails = [];
            this.qrCodeSetup.qrCodeRoleDetails = [];
            //set 'Access' field default value to private
            this.qrCodeSetupForm.controls["accessType"].setValue("Private");
            this.qrCodeSetupForm.controls["roleAccessType"].setValue("RoleBased");
        }
        else {
            if (this.qrCodeSetup.id > 0) {
                if (this.qrCodeSetup.roleAccessType == "Non Role Based") {
                    let qrCodeTypeDetail = this.qrCodeSetup.qrCodeTypeDetails.find(x => x.type == QRCodeTypes[QRCodeTypes.View]);
                    if (qrCodeTypeDetail) {
                        this.qrCodeSetupForm.controls["roleAccessType"].setValue("NonRoleBased");
                        this.qrCodeSetupForm.controls["type"].setValue("View");
                        this.qrCodeSetupForm.controls["accessType"].setValue(qrCodeTypeDetail.accessType);
                    }
                }
                else if ((this.qrCodeSetup.roleAccessType == "Role Based")) {
                    this.qrCodeSetupForm.controls["roleAccessType"].setValue("RoleBased");
                }
            }
        }

        this.globals.hideSpinner();
    }

    async ngOnChanges() {
        this.setFormId();
        if (this.formId > 0) {
            //get the form entity from form service
            var entity = await (this.formService as FormsService).get(this.formId).toPromise();

            //filter out specific type of questions
            if (entity && entity.questions.length > 0) {
                this.qrCodeFormQuesOptions = entity.questions.filter(
                    (x) =>
                        (x.type == "Text" ||
                            x.type == "Dropdown" ||
                            x.type == "Date" ||
                            x.type == "Checkbox") &&
                        x.label != null
                );
            }
            this.qrCodeFormQuesOptions.map(remoteQuestionEntity => {
                let localQuestionEntity = this.qrCodeFormQuestions.find(
                    x =>
                        x.id == remoteQuestionEntity.id &&
                        x.label !== remoteQuestionEntity.label
                );

                //if the local question label entity  doesn't match api question label entity
                //then set local question label entity
                if (localQuestionEntity) {
                    remoteQuestionEntity.label = localQuestionEntity.label;
                }
            })
        }

        if (this.selectedPopulate1FormQuesRegister) {
            this.selectedPopulate1FormQuesRegister.forEach((selectedPopulate1FormQuesRegister, index) => {
                let qrCodeFormQuestion = this.qrCodeFormQuestions.filter(x => x.id == selectedPopulate1FormQuesRegister.id);
                if (qrCodeFormQuestion.length == 0)
                    this.deleteQuestion(1, index);
            })
        }
        else if (this.selectedPopulate2FormQuesRegister) {
            this.selectedPopulate2FormQuesRegister.forEach((selectedPopulate2FormQuesRegister, index) => {
                let qrCodeFormQuestion = this.qrCodeFormQuestions.filter(x => x.id == selectedPopulate2FormQuesRegister.id);
                if (qrCodeFormQuestion.length == 0)
                    this.deleteQuestion(2, index);
            })
        }
        else if (this.selectedPopulate3FormQuesRegister) {
            this.selectedPopulate3FormQuesRegister.forEach((selectedPopulate3FormQuesRegister, index) => {
                let qrCodeFormQuestion = this.qrCodeFormQuestions.filter(x => x.id == selectedPopulate3FormQuesRegister.id);
                if (qrCodeFormQuestion.length == 0)
                    this.deleteQuestion(3, index);
            })
        }
        else if (this.selectedPopulate4FormQuesRegister) {
            this.selectedPopulate4FormQuesRegister.forEach((selectedPopulate4FormQuesRegister, index) => {
                let qrCodeFormQuestion = this.qrCodeFormQuestions.filter(x => x.id == selectedPopulate4FormQuesRegister.id);
                if (qrCodeFormQuestion.length == 0)
                    this.deleteQuestion(4, index);
            })
        }
    }

    //#endregion

    //#region Methods for Data bind
    bindFormControls() {
        this.qrCodeSetupForm = new FormGroup({
            name: new FormControl({ value: this.qrCodeSetup.name, disabled: this.isViewMode }, {
                validators: [Validators.required, Validators.maxLength(25)],
                updateOn: "change"
            }),
            lastUpdatedBy: new FormControl
                (
                    {
                        value: (this.qrCodeSetup.modifiedBy != "" ? this.qrCodeSetup.modifiedBy : this.qrCodeSetup.createdBy ?? ""),
                        disabled: true
                    }
                ),
            updateOn: new FormControl
                (
                    {
                        value: new DatePipe("en-US").transform(
                            this.qrCodeSetup.modified ? this.qrCodeSetup.modified : this.qrCodeSetup.created, "yyyy-MM-dd HH:mm"
                        ),
                        disabled: true
                    }
                ),
            status: new FormControl({ value: this.qrCodeSetup.isActive, disabled: this.isViewMode }, { updateOn: "change" }),

            roleAccessType: new FormControl(
                {
                    value: this.qrCodeSetup.roleAccessType, disabled: this.isViewMode
                },
                {
                    updateOn: "change"
                }
            ),
            type: new FormControl({ value: "", disabled: this.isViewMode }, { updateOn: "change" }),
            accessType: new FormControl({ value: "", disabled: this.isViewMode }, { updateOn: "change" }),
            formQuestionPopulate1: new FormControl({ value: "", disabled: this.isViewMode }),
            formQuestionPopulate2: new FormControl({ value: "", disabled: this.isViewMode }),
            formQuestionPopulate3: new FormControl({ value: "", disabled: this.isViewMode }),
            formQuestionPopulate4: new FormControl({ value: "", disabled: this.isViewMode })
        });
    }

    bindFormQuestionControlValidations() {
        for (let index = 3; index <= 6; index++) {
            let selectedQRCodeFormQuesRegister = [];
            if (index == 3) {
                selectedQRCodeFormQuesRegister = this.selectedPopulate1FormQuesRegister;
            }
            else if (index == 4) {
                selectedQRCodeFormQuesRegister = this.selectedPopulate2FormQuesRegister;
            }
            else if (index == 5) {
                selectedQRCodeFormQuesRegister = this.selectedPopulate3FormQuesRegister;
            }
            else if (index == 6) {
                selectedQRCodeFormQuesRegister = this.selectedPopulate4FormQuesRegister;
            }

            let formQuestions = selectedQRCodeFormQuesRegister.length > 0 ? selectedQRCodeFormQuesRegister : this.qrCodeFormQuestions;
            formQuestions.forEach(formQuestion => {
                let formControlName = 'formQuestion_' + QRCodeTypes[index] + "_" + formQuestion.id;
                if (formQuestion.type == "Date") {
                    this.qrCodeSetupForm
                        .addControl(
                            formControlName,
                            new FormControl(
                                {
                                    value: "",
                                    disabled: this.isViewMode
                                },
                                {
                                    validators:
                                        [
                                            Validators.required
                                        ],
                                    updateOn: "change"
                                }
                            )
                        )
                }
                else if (formQuestion.type == "Dropdown") {
                    this.qrCodeSetupForm
                        .addControl(
                            formControlName,
                            new FormControl(
                                {
                                    value: "",
                                    disabled: this.isViewMode
                                },
                                {
                                    validators:
                                        [
                                            Validators.required
                                        ],
                                    updateOn: "change"
                                }
                            )
                        )
                }
                else if (formQuestion.type == "Checkbox") {
                    this.qrCodeSetupForm
                        .addControl(
                            formControlName,
                            new FormControl(
                                {
                                    value: "",
                                    disabled: this.isViewMode
                                },
                                {
                                    validators:
                                        [
                                            Validators.required
                                        ],
                                    updateOn: "change"
                                }
                            )
                        )
                }
                else if (formQuestion.type == "Text" && formQuestion.extendedType == "Long") {
                    this.qrCodeSetupForm
                        .addControl(
                            formControlName,
                            new FormControl(
                                {
                                    value: "",
                                    disabled: this.isViewMode
                                },
                                {
                                    validators:
                                        [
                                            Validators.required
                                        ],
                                    updateOn: "change"
                                }
                            )
                        )
                }
                else if (formQuestion.type == "Text" && formQuestion.extendedType == "Number") {
                    this.qrCodeSetupForm
                        .addControl(
                            formControlName,
                            new FormControl(
                                {
                                    value: "",
                                    disabled: this.isViewMode
                                },
                                {
                                    validators:
                                        [
                                            Validators.required,
                                            Validators.pattern(/^[0-9]\d*$/),
                                            Validators.min(0)
                                        ],
                                    updateOn: "change"
                                }
                            )
                        )
                }
                else if (formQuestion.type == "Text" && formQuestion.extendedType == "Hyperlink") {
                    this.qrCodeSetupForm
                        .addControl(
                            formControlName,
                            new FormControl(
                                {
                                    value: "",
                                    disabled: this.isViewMode
                                },
                                {
                                    validators:
                                        [
                                            Validators.required,
                                            Validators.pattern(/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/)
                                        ],
                                    updateOn: "change"
                                }
                            )
                        )
                }
            });
        }
    }

    private async roleBind(): Promise<void> {
        let typeValuelist: string[] = [
            "EmployeeRole",
            "ContactRole",
            "SubContractorPosition",
            "MaterialSupplierPosition",
            "PlantSupplierPosition"
        ];
        let typeNamelist: string[] = [
            "Admin - Employees - Job Roles",
            "Admin - Organisation/Contacts - Contact Role",
            "Subcontractors - Positions",
            "Plant & Materials - Materials Admin/Supplier Directory - Positions",
            "Plant & Materials - Plant Admin/Supplier Directory - Positions"
        ];
        let sortNamelist: string[] = [
            "Employee",
            "Organisation",
            "Subcontractor",
            "Material",
            "Plant"
        ];
        let arr: number[] = [0, 1, 2, 3, 4, 5, 6];
        await arr?.forEach(i => {
            this.itemListGeneral.push([]);
            typeValuelist?.forEach((roletype, index) => {
                this.lookupValuesService
                    .getLookupValues(roletype)
                    .subscribe(result => {
                        result?.forEach(item => {
                            if (item.status == 'Active') {
                                this.itemListGeneral[i].push(
                                    {
                                        "order": index,
                                        "id": item.id,
                                        "itemName": item.name + " (" + sortNamelist[index] + ")",
                                        "category": typeNamelist[index],
                                        "disabled": false
                                    }
                                );
                            }
                        }); this.itemListGeneral[i] = this.itemListGeneral[i].sort((o2, o1) => o2.order - o1.order);
                    },
                        () => {
                            this.asyncModalService.getModalResponse("Failed to load Roles");
                        }
                    )
            });
        });

    }

    //#endregion

    //#region Methods for Question 

    addRemoveQRCodeFormQues(populateSubType: number, event) {
        let selectedQRCodeFormQuesRegister = [];
        if (populateSubType == 3) {
            selectedQRCodeFormQuesRegister = this.selectedPopulate1FormQuesRegister;
        }
        else if (populateSubType == 4) {
            selectedQRCodeFormQuesRegister = this.selectedPopulate2FormQuesRegister;
        }
        else if (populateSubType == 5) {
            selectedQRCodeFormQuesRegister = this.selectedPopulate3FormQuesRegister;
        }
        else if (populateSubType == 6) {
            selectedQRCodeFormQuesRegister = this.selectedPopulate4FormQuesRegister;
        }

        //if single question selected/de-selected
        if (event.itemValue) {
            //if single question selected
            if (event.value.indexOf(event.itemValue.id) > -1) {
                this.addFormToExportQuestion(populateSubType, event.itemValue.id);
            }
            //if single question de-selected
            else if (event.value.indexOf(event.itemValue.id) == -1) {
                let currSelectQuesIndex = selectedQRCodeFormQuesRegister.findIndex(formSelectedQuestion => formSelectedQuestion.id == event.itemValue.id);
                if (currSelectQuesIndex > -1)
                    selectedQRCodeFormQuesRegister.splice(currSelectQuesIndex, 1);

                if (populateSubType == 3) {
                    this.selectedPopulate1FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
                else if (populateSubType == 4) {
                    this.selectedPopulate2FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
                else if (populateSubType == 5) {
                    this.selectedPopulate3FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
                else if (populateSubType == 6) {
                    this.selectedPopulate4FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
            }
        }
        //if multiple question selected/de-selected
        else if (!event.itemValue) {
            if (event.value.length > 0) {
                //if multiple question selected
                event.value.forEach(element => {
                    this.addFormToExportQuestion(populateSubType, element);
                });
            }
            //if multiple question de-selected
            else if (event.value.length == 0) {
                selectedQRCodeFormQuesRegister = [];

                if (populateSubType == 3) {
                    this.selectedPopulate1FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
                else if (populateSubType == 4) {
                    this.selectedPopulate2FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
                else if (populateSubType == 5) {
                    this.selectedPopulate3FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
                else if (populateSubType == 6) {
                    this.selectedPopulate4FormQuesRegister = selectedQRCodeFormQuesRegister;
                }
            }
        }
    }

    removeQRCodeFormQuestion(populateSubType: number, index: number, events?: Event) {
        if (events) {
            events.stopPropagation();
            events.preventDefault();
        }
        this.deleteQuestion(populateSubType, index)
    }

    onSubmit() {
        this.allAccordianOpenOnce();
        //check if form is valid
        if (!this.isFormValid())
            return false;
        else {
            if (this.formId > 0 && !this.isViewMode) {
                //set export form field
                this.mapQRCodeSetup();
                if (this.qrCodeSetup.id > 0 && this.isEditMode)
                    this.update();
                else if (this.qrCodeSetup.id == 0 && !this.isEditMode)
                    this.add();
            }
        }
    }

    roleSearchText: { [key: number]: string } = {};

    getRoleSelection(type: number): any[] {
        switch (type) {
            case 0: return this.createRoleSelectedItems;
            case 1: return this.updateRoleSelectedItems;
            case 2: return this.viewRoleSelectedItems;
            case 3: return this.populate1RoleSelectedItems;
            case 4: return this.populate2RoleSelectedItems;
            case 5: return this.populate3RoleSelectedItems;
            case 6: return this.populate4RoleSelectedItems;
            default: return [];
        }
    }

    setRoleSelection(type: number, value: any[]): void {
        switch (type) {
            case 0: this.createRoleSelectedItems = value; break;
            case 1: this.updateRoleSelectedItems = value; break;
            case 2: this.viewRoleSelectedItems = value; break;
            case 3: this.populate1RoleSelectedItems = value as []; break;
            case 4: this.populate2RoleSelectedItems = value as []; break;
            case 5: this.populate3RoleSelectedItems = value as []; break;
            case 6: this.populate4RoleSelectedItems = value as []; break;
        }
    }

    // Drives the Populate 1-4 *ngFor in the template (num = display number,
    // subType = the QRCodeTypes index used everywhere else: 3-6). Kept
    // alongside the getRoleSelection/setRoleSelection dispatch above so the
    // question-picker/table side of Populate 1-4 can share one template
    // instead of four literal copies.
    populateTypes = [
        { num: 1, subType: 3 },
        { num: 2, subType: 4 },
        { num: 3, subType: 5 },
        { num: 4, subType: 6 },
    ];

    getSelectedFormQuestionId(num: number): number[] {
        switch (num) {
            case 1: return this.selectedPopulate1FormQuestionId;
            case 2: return this.selectedPopulate2FormQuestionId;
            case 3: return this.selectedPopulate3FormQuestionId;
            case 4: return this.selectedPopulate4FormQuestionId;
        }
    }

    setSelectedFormQuestionId(num: number, value: number[]): void {
        switch (num) {
            case 1: this.selectedPopulate1FormQuestionId = value; break;
            case 2: this.selectedPopulate2FormQuestionId = value; break;
            case 3: this.selectedPopulate3FormQuestionId = value; break;
            case 4: this.selectedPopulate4FormQuestionId = value; break;
        }
    }

    getSelectedFormQuesRegister(num: number): Question[] {
        switch (num) {
            case 1: return this.selectedPopulate1FormQuesRegister;
            case 2: return this.selectedPopulate2FormQuesRegister;
            case 3: return this.selectedPopulate3FormQuesRegister;
            case 4: return this.selectedPopulate4FormQuesRegister;
        }
    }

    getGroupedRoleList(index: number): any[] {
        return (this.itemListGeneral[index] || []).reduce((acc, item) => {
            const existing = acc.find(g => g.category === item.category);
            if (existing) { existing.items.push(item); }
            else { acc.push({ category: item.category, items: [item] }); }
            return acc;
        }, []);
    }

    // getFilteredRoleGroups() (called directly from *ngFor in the template)
    // builds a brand new array/objects on every call via reduce(), even when
    // the actual filtered content hasn't changed. Without trackBy, Angular
    // sees a "different" array on every change-detection cycle - including
    // the cycle triggered by a checkbox's own mousedown - and destroys/
    // recreates the checkbox DOM nodes mid-click, which silently swallows
    // that first click (a second click then works since the list is stable).
    trackByRoleCategory(index: number, group: any): string {
        return group.category;
    }

    trackByRoleItemId(index: number, item: any): number {
        return item.id;
    }

    getFilteredRoleGroups(index: number): any[] {
        const groups = this.getGroupedRoleList(index);
        const search = (this.roleSearchText[index] || '').toLowerCase();
        if (!search) return groups;
        return groups
            .filter(g => g.category.toLowerCase().includes(search) || g.items.some(item => item.itemName.toLowerCase().includes(search)))
            .map(g => ({
                ...g,
                items: g.category.toLowerCase().includes(search) ? g.items : g.items.filter(item => item.itemName.toLowerCase().includes(search))
            }));
    }

    isRoleItemSelected(item: any, type: number): boolean {
        // Use loose equality to handle number/string id type mismatches
        return (this.getRoleSelection(type) || []).some(s => s.id == item.id);
    }

    isRoleGroupSelected(group: any, type: number): boolean {
        const enabled = group.items.filter(i => !i.disabled);
        return enabled.length > 0 && enabled.every(item => this.isRoleItemSelected(item, type));
    }

    isRoleGroupIndeterminate(group: any, type: number): boolean {
        const enabled = group.items.filter(i => !i.disabled);
        const selected = enabled.filter(item => this.isRoleItemSelected(item, type)).length;
        return selected > 0 && selected < enabled.length;
    }

    isAllRoleSelected(index: number): boolean {
        const all = this.getGroupedRoleList(index).reduce((acc, g) => acc.concat(g.items.filter(i => !i.disabled)), []);
        return all.length > 0 && all.every(item => this.isRoleItemSelected(item, index));
    }

    removeRoleChip(item: any, type: number): void {
        this.setRoleSelection(type, (this.getRoleSelection(type) || []).filter(s => s.id != item.id));
        this.onRoleChange({ value: this.getRoleSelection(type) }, type);
    }

    toggleRoleItem(item: any, event: Event, type: number): void {
        if (item.disabled) return;
        const checked = (event.target as HTMLInputElement).checked;
        const current = this.getRoleSelection(type) || [];
        this.setRoleSelection(type, checked ? [...current, item] : current.filter(s => s.id != item.id));
        this.onRoleChange({ value: this.getRoleSelection(type) }, type);
    }

    toggleRoleGroup(group: any, event: Event, type: number): void {
        const checked = (event.target as HTMLInputElement).checked;
        const current = this.getRoleSelection(type) || [];
        const enabledItems = group.items.filter(i => !i.disabled);
        if (checked) {
            const newItems = enabledItems.filter(item => !this.isRoleItemSelected(item, type));
            this.setRoleSelection(type, [...current, ...newItems]);
        } else {
            this.setRoleSelection(type, current.filter(s => !enabledItems.some(item => item.id == s.id)));
        }
        this.onRoleChange({ value: this.getRoleSelection(type) }, type);
    }

    toggleRoleSelectAll(event: Event, index: number): void {
        const checked = (event.target as HTMLInputElement).checked;
        const enabled = this.getGroupedRoleList(index).reduce((acc, g) => acc.concat(g.items.filter(i => !i.disabled)), []);
        this.setRoleSelection(index, checked ? enabled : []);
        this.onRoleChange({ value: this.getRoleSelection(index) }, index);
    }

    onRoleChange(event: any, type: number) {
        // PrimeNG MultiSelect onChange event
        // event.value contains the current selection
        // We need to determine what was added or removed
        
        let currentSelection = event.value || [];
        let previousSelection: any[] = [];
        
        // Get previous selection based on type
        switch(type) {
            case 0: previousSelection = this.createRoleSelectedItems || []; break;
            case 1: previousSelection = this.updateRoleSelectedItems || []; break;
            case 2: previousSelection = this.viewRoleSelectedItems || []; break;
            case 3: previousSelection = this.populate1RoleSelectedItems || []; break;
            case 4: previousSelection = this.populate2RoleSelectedItems || []; break;
            case 5: previousSelection = this.populate3RoleSelectedItems || []; break;
            case 6: previousSelection = this.populate4RoleSelectedItems || []; break;
        }

        // Find added items
        const addedItems = currentSelection.filter(item => 
            !previousSelection.some(prev => prev.id === item.id)
        );
        
        // Find removed items
        const removedItems = previousSelection.filter(item => 
            !currentSelection.some(curr => curr.id === item.id)
        );

        // Handle added items - disable in other lists
        addedItems.forEach(item => {
            for (let i = 0; i <= 6; i++) {
                if (i !== type && this.itemListGeneral[i]) {
                    this.itemListGeneral[i] = this.itemListGeneral[i].map(y => {
                        if (y.id === item.id) y.disabled = true;
                        return y;
                    });
                }
            }
        });

        // Handle removed items - enable in other lists
        removedItems.forEach(item => {
            for (let i = 0; i <= 6; i++) {
                if (i !== type && this.itemListGeneral[i]) {
                    this.itemListGeneral[i] = this.itemListGeneral[i].map(y => {
                        if (y.id === item.id) y.disabled = false;
                        return y;
                    });
                }
            }
        });
    }

    onItemSelect(item: any, type: number) {
        for (let i = 0; i <= 6; i++) {
            if (i != type) {
                this.itemListGeneral[i] = this.itemListGeneral[i].map(y => { if (y.id == item.id) y.disabled = true; return y; });
            }
        }
    }
    onItemDeSelect(item: any, type: number) {
        for (let i = 0; i <= 6; i++) {
            if (i != type) {
                this.itemListGeneral[i] = this.itemListGeneral[i].map(y => { if (y.id == item.id) y.disabled = false; return y; });
            }
        }
    }
    onSelectAll(items: any, type: number) {
        for (let i = 0; i <= 6; i++) {
            if (i != type) {
                (items || []).forEach(a => {
                    this.itemListGeneral[i] = this.itemListGeneral[i].map(y => { if (y.id == a.id) y.disabled = true; return y; });
                });
            }
        }
    }
    onDeSelectAll(items: any, type: number) {
        for (let i = 0; i <= 6; i++) {
            if (i != type) {
                (items || []).forEach(a => {
                    this.itemListGeneral[i] = this.itemListGeneral[i].map(y => { if (y.id == a.id) y.disabled = false; return y; });
                });
            }
        }
    }

    onQRCodeCreateTypeTabOpen() {
        this.createAccordionOpened = true;
        if (this.qrCodeSetup.id > 0 && this.createRoleSelectedItems.length == 0) {
            this.qrCodeSetup.qrCodeRoleDetails.forEach(qrCodeRoleDetail => {
                if (qrCodeRoleDetail.type == QRCodeTypes[QRCodeTypes.Create]) {
                    this.itemListGeneral[0].forEach(element => {
                        if (element.id == qrCodeRoleDetail.roleId) {
                            let exists = this.createRoleSelectedItems.find(x => x.id == element.id);
                            if (!exists)
                                this.createRoleSelectedItems.push(element);
                        }
                    });
                }
            });
        }

        for (let i = 0; i <= 6; i++) {
            if (i != 0) {
                this.itemListGeneral[i] = this.itemListGeneral[i].map(y => {
                    let foundItem = this.createRoleSelectedItems.find(x => x.id == y.id);
                    if (foundItem) y.disabled = true; return y;
                });
            }
        }
        this.allAccordianOpenOnce();
    }

    onQRCodeUpdateTypeTabOpen() {
        this.updateAccordionOpened = true;
        if (this.qrCodeSetup.id > 0 && this.updateRoleSelectedItems.length == 0) {
            this.qrCodeSetup.qrCodeRoleDetails.forEach(qrCodeRoleDetail => {
                if (qrCodeRoleDetail.type == QRCodeTypes[QRCodeTypes.Update]) {
                    this.itemListGeneral[1].forEach(element => {
                        if (element.id == qrCodeRoleDetail.roleId) {
                            let exists = this.updateRoleSelectedItems.find(x => x.id == element.id);
                            if (!exists)
                                this.updateRoleSelectedItems.push(element);
                        }
                    });
                }
            });

            for (let i = 0; i <= 6; i++) {
                if (i != 1) {
                    this.itemListGeneral[i] = this.itemListGeneral[i].map(y => {
                        let foundItem = this.updateRoleSelectedItems.find(x => x.id == y.id);
                        if (foundItem) y.disabled = true; return y;
                    });
                }
            }
        }
        this.allAccordianOpenOnce();
    }

    onQRCodePopulateTypeTabOpen(populateSubType: number) {
        if (this.qrCodeSetup.id > 0) {
            let populateRoleSelectedItems: any = [];
            let selectedQRCodeFormQuestionId = [];
            let selectedQRCodeFormQuesRegister = [];
            this.qrCodeSetup.qrCodeRoleDetails.find(x => x.type == QRCodeTypes[populateSubType]);

            if (populateSubType == 3) {
                this.populate1AccordionOpened = true;
                populateRoleSelectedItems = this.populate1RoleSelectedItems;
                selectedQRCodeFormQuestionId = this.selectedPopulate1FormQuestionId;
                selectedQRCodeFormQuesRegister = this.selectedPopulate1FormQuesRegister;
            }
            else if (populateSubType == 4) {
                this.populate2AccordionOpened = true;
                populateRoleSelectedItems = this.populate2RoleSelectedItems;
                selectedQRCodeFormQuestionId = this.selectedPopulate2FormQuestionId;
                selectedQRCodeFormQuesRegister = this.selectedPopulate2FormQuesRegister;
            }
            else if (populateSubType == 5) {
                this.populate3AccordionOpened = true;
                populateRoleSelectedItems = this.populate3RoleSelectedItems;
                selectedQRCodeFormQuestionId = this.selectedPopulate3FormQuestionId;
                selectedQRCodeFormQuesRegister = this.selectedPopulate3FormQuesRegister;
            }
            else if (populateSubType == 6) {
                this.populate4AccordionOpened = true;
                populateRoleSelectedItems = this.populate4RoleSelectedItems;
                selectedQRCodeFormQuestionId = this.selectedPopulate4FormQuestionId;
                selectedQRCodeFormQuesRegister = this.selectedPopulate4FormQuesRegister;
            }

            if (populateRoleSelectedItems.length == 0) {
                this.qrCodeSetup.qrCodeRoleDetails.forEach(qrCodeRoleDetail => {
                    if (qrCodeRoleDetail.type == QRCodeTypes[populateSubType]) {
                        this.itemListGeneral[populateSubType].forEach(element => {
                            if (element.id == qrCodeRoleDetail.roleId) {
                                let exists = populateRoleSelectedItems.find(x => x.id == element.id);
                                if (!exists)
                                    populateRoleSelectedItems.push(element);
                            }
                        });
                    }
                });

                for (let i = 0; i <= 6; i++) {
                    if (i != populateSubType) {
                        this.itemListGeneral[i] = this.itemListGeneral[i].map(y => {
                            let foundItem = populateRoleSelectedItems.find(x => x.id == y.id);
                            if (foundItem) y.disabled = true; return y;
                        });
                    }
                }

                if (populateSubType == 3) {
                    this.populate1RoleSelectedItems = populateRoleSelectedItems;
                }
                else if (populateSubType == 4) {
                    this.populate2RoleSelectedItems = populateRoleSelectedItems;
                }
                else if (populateSubType == 5) {
                    this.populate3RoleSelectedItems = populateRoleSelectedItems;
                }
                else if (populateSubType == 6) {
                    this.populate4RoleSelectedItems = populateRoleSelectedItems;
                }
            }

            if (this.qrCodeSetup.qrCodeTypeDetails.length > 0 &&
                selectedQRCodeFormQuestionId.length == 0) {
                let qrCodePopulateTypeDetail = this.qrCodeSetup.qrCodeTypeDetails.find(x => x.type == QRCodeTypes[populateSubType]);
                let questionIds = qrCodePopulateTypeDetail?.qrCodeQuestions.map(x => {
                    return x.questionId
                });

                let selectedQRCodeFormQuestions = this.qrCodeFormQuestions?.filter(x => (questionIds?.indexOf(x.id) > -1));
                selectedQRCodeFormQuestions.map(selectedQRCodeFormQuestion => {
                    selectedQRCodeFormQuestionId.push(selectedQRCodeFormQuestion.id);
                    selectedQRCodeFormQuesRegister.push(selectedQRCodeFormQuestion);
                    this.changeDetector.detectChanges();
                    let quesValue = qrCodePopulateTypeDetail.qrCodeQuestions.find(x => x.questionId == selectedQRCodeFormQuestion.id);
                    if (selectedQRCodeFormQuestion.type == "Dropdown")
                        this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[populateSubType] + "_" + selectedQRCodeFormQuestion.id].setValue(+quesValue.value);
                    else if (selectedQRCodeFormQuestion.type == "Checkbox") {
                        let quesValuecb = qrCodePopulateTypeDetail.qrCodeQuestions.filter(x => x.questionId == selectedQRCodeFormQuestion.id).map(t => Number(t.value));
                        this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[populateSubType] + "_" + selectedQRCodeFormQuestion.id].setValue(quesValuecb);
                    }
                    else if (selectedQRCodeFormQuestion.type == "Date" && quesValue.value != '')
                        this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[populateSubType] + "_" + selectedQRCodeFormQuestion.id].setValue(new Date(quesValue.value));
                    else
                        this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[populateSubType] + "_" + selectedQRCodeFormQuestion.id].setValue(quesValue.value);
                });

                if (populateSubType == 3) {
                    this.qrCodeSetupForm.controls["formQuestionPopulate1"].setValue(selectedQRCodeFormQuestionId);
                    this.selectedPopulate1FormQuesRegister = selectedQRCodeFormQuesRegister;
                    this.changeDetector.detectChanges();
                }
                else if (populateSubType == 4) {
                    this.qrCodeSetupForm.controls["formQuestionPopulate2"].setValue(selectedQRCodeFormQuestionId);
                    this.selectedPopulate2FormQuesRegister = selectedQRCodeFormQuesRegister;
                    this.changeDetector.detectChanges();
                }
                else if (populateSubType == 5) {
                    this.qrCodeSetupForm.controls["formQuestionPopulate3"].setValue(selectedQRCodeFormQuestionId);
                    this.selectedPopulate3FormQuesRegister = selectedQRCodeFormQuesRegister;
                    this.changeDetector.detectChanges();
                }
                else if (populateSubType == 6) {
                    this.qrCodeSetupForm.controls["formQuestionPopulate4"].setValue(selectedQRCodeFormQuestionId);
                    this.selectedPopulate4FormQuesRegister = selectedQRCodeFormQuesRegister;
                    this.changeDetector.detectChanges();
                }
            }
        }

        this.allAccordianOpenOnce();
    }

    onQRCodeViewTypeTabOpen() {
        this.viewAccordionOpened = true;
        if (this.qrCodeSetup.id > 0) {
            if (this.viewRoleSelectedItems.length == 0) {
                this.qrCodeSetup.qrCodeRoleDetails.forEach(qrCodeRoleDetail => {
                    if (qrCodeRoleDetail.type == QRCodeTypes[QRCodeTypes.View]) {
                        this.itemListGeneral[2].forEach(element => {
                            if (element.id == qrCodeRoleDetail.roleId) {
                                let exists = this.viewRoleSelectedItems.find(x => x.id == element.id);
                                if (!exists)
                                    this.viewRoleSelectedItems.push(element);
                            }
                        });
                    }
                });

                for (let i = 0; i <= 6; i++) {
                    if (i != 2) {
                        this.itemListGeneral[i] = this.itemListGeneral[i].map(y => {
                            let foundItem = this.viewRoleSelectedItems.find(x => x.id == y.id);
                            if (foundItem) y.disabled = true; return y;
                        });
                    }
                }
            }

            this.qrCodeSetup.qrCodeTypeDetails.find(x => x.type == QRCodeTypes[QRCodeTypes.View]);

        }
        this.allAccordianOpenOnce();
    }

    closeQRCodeSetupModal() {
        this.onCloseQRCodeSetting.emit();
    }

    private deleteQuestion(populateSubType: number, index: number) {
        let selectedPopulateFormQuestionId = [];
        let selectedPopulateFormQuesRegister = [];

        if (populateSubType == 3) {
            selectedPopulateFormQuestionId = this.selectedPopulate1FormQuestionId;
            selectedPopulateFormQuesRegister = this.selectedPopulate1FormQuesRegister;
        }
        else if (populateSubType == 4) {
            selectedPopulateFormQuestionId = this.selectedPopulate2FormQuestionId;
            selectedPopulateFormQuesRegister = this.selectedPopulate2FormQuesRegister;
        }
        else if (populateSubType == 5) {
            selectedPopulateFormQuestionId = this.selectedPopulate3FormQuestionId;
            selectedPopulateFormQuesRegister = this.selectedPopulate3FormQuesRegister;
        }
        else if (populateSubType == 6) {
            selectedPopulateFormQuestionId = this.selectedPopulate4FormQuestionId;
            selectedPopulateFormQuesRegister = this.selectedPopulate4FormQuesRegister;
        }

        if (selectedPopulateFormQuestionId[index] != null) {
            selectedPopulateFormQuesRegister = selectedPopulateFormQuesRegister.filter(x => x.id !== selectedPopulateFormQuestionId[index]);
            selectedPopulateFormQuestionId = selectedPopulateFormQuestionId.filter(id => id !== selectedPopulateFormQuestionId[index]);
        }

        if (populateSubType == 3) {
            this.selectedPopulate1FormQuestionId = selectedPopulateFormQuestionId;
            this.selectedPopulate1FormQuesRegister = selectedPopulateFormQuesRegister;
        }
        else if (populateSubType == 4) {
            this.selectedPopulate2FormQuestionId = selectedPopulateFormQuestionId;
            this.selectedPopulate2FormQuesRegister = selectedPopulateFormQuesRegister;
        }
        else if (populateSubType == 5) {
            this.selectedPopulate3FormQuestionId = selectedPopulateFormQuestionId;
            this.selectedPopulate3FormQuesRegister = selectedPopulateFormQuesRegister;
        }
        else if (populateSubType == 6) {
            this.selectedPopulate4FormQuestionId = selectedPopulateFormQuestionId;
            this.selectedPopulate4FormQuesRegister = selectedPopulateFormQuesRegister;
        }
    }

    private addFormToExportQuestion(populateSubType: number, formQuestionId: number) {
        let localSelectedQRCodeFormQuesRegister = [];
        if (populateSubType == 3) {
            localSelectedQRCodeFormQuesRegister = this.selectedPopulate1FormQuesRegister;
        }
        else if (populateSubType == 4) {
            localSelectedQRCodeFormQuesRegister = this.selectedPopulate2FormQuesRegister;
        }
        else if (populateSubType == 5) {
            localSelectedQRCodeFormQuesRegister = this.selectedPopulate3FormQuesRegister;
        }
        else if (populateSubType == 6) {
            localSelectedQRCodeFormQuesRegister = this.selectedPopulate4FormQuesRegister;
        }

        let formQuestionExist = localSelectedQRCodeFormQuesRegister.find(x => x.id == formQuestionId);
        if (typeof formQuestionExist == 'undefined') {
            let formQuestion = this.qrCodeFormQuesOptions.find(x => x.id == formQuestionId);
            localSelectedQRCodeFormQuesRegister.push(formQuestion);
            if (formQuestion.type == 'Dropdown')
                this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[populateSubType] + "_" + formQuestion.id].setValue(+formQuestion?.options[0]?.id);
            else
                this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[populateSubType] + "_" + formQuestion.id].setValue('');
        }

        if (populateSubType == 3) {
            this.selectedPopulate1FormQuesRegister = localSelectedQRCodeFormQuesRegister;
        }
        else if (populateSubType == 4) {
            this.selectedPopulate2FormQuesRegister = localSelectedQRCodeFormQuesRegister;
        }
        else if (populateSubType == 5) {
            this.selectedPopulate3FormQuesRegister = localSelectedQRCodeFormQuesRegister;
        }
        else if (populateSubType == 6) {
            this.selectedPopulate4FormQuesRegister = localSelectedQRCodeFormQuesRegister;
        }
    }

    //#endregion

    private add() {
        //add qrcode setup setting
        this.qrCodeService.create(this.qrCodeSetup).subscribe(
            () => {
            },
            (err) => {
                this.asyncModalService.getModalResponse(err.error);
            },
            () => {
                this.closeQRCodeSetupButton.nativeElement.click();
                this.onSaveQRCodeSetting.emit();
            }
        );
    }

    private update() {
        this.qrCodeService.update(this.qrCodeSetup).subscribe(
            () => {
            },
            (err) => {
                this.asyncModalService.getModalResponse(err.error);
            },
            () => {
                this.closeQRCodeSetupButton.nativeElement.click();
                this.onSaveQRCodeSetting.emit();
            }
        );
    }


    private mapQRCodeSetup() {
        this.qrCodeSetup.name = this.qrCodeSetupForm.controls["name"].value ?? 0;
        this.qrCodeSetup.formId = this.formId ?? 0;
        this.qrCodeSetup.entryNumber = this.qrCodeSetup.entryNumber ?? 0;
        this.qrCodeSetup.roleAccessType = this.qrCodeSetupForm.controls["roleAccessType"].value;
        this.qrCodeSetup.isActive = this.qrCodeSetupForm.controls["status"].value;
        this.qrCodeSetup.qrCodeRoleDetails = [];
        this.qrCodeSetup.qrCodeTypeDetails = [];

        if (this.qrCodeSetup.roleAccessType == QRCodeRoleAccessType[QRCodeRoleAccessType.NonRoleBased]) {
            this.mapQRCodeTypeDetail(QRCodeTypes.View);
        }
        else if (this.qrCodeSetup.roleAccessType == QRCodeRoleAccessType[QRCodeRoleAccessType.RoleBased]) {

            //qr code type accordion
            this.createRoleSelectedItems.forEach(createRoleSelected => {
                this.mapQRCodeTypeDetail(QRCodeTypes.Create);
                this.mapQRCodeRoleDetail(createRoleSelected, QRCodeTypes.Create);
            });
            this.updateRoleSelectedItems.forEach(updateRoleSelected => {
                this.mapQRCodeTypeDetail(QRCodeTypes.Update);
                this.mapQRCodeRoleDetail(updateRoleSelected, QRCodeTypes.Update);
            });
            let index = 0;
            while (index <= 3) {
                let populateRoleSelectedItems = [];
                if (index == 0)
                    populateRoleSelectedItems = this.populate1RoleSelectedItems;
                else if (index == 1)
                    populateRoleSelectedItems = this.populate2RoleSelectedItems;
                else if (index == 2)
                    populateRoleSelectedItems = this.populate3RoleSelectedItems;
                else if (index == 3)
                    populateRoleSelectedItems = this.populate4RoleSelectedItems;

                populateRoleSelectedItems.forEach(populateRoleSelected => {
                    let qrCodeType = QRCodeTypes[QRCodeTypes[index + 3]];
                    this.mapQRCodeTypeDetail(qrCodeType);
                    this.mapQRCodeRoleDetail(populateRoleSelected, qrCodeType);
                });
                index++;
            }
            this.viewRoleSelectedItems.forEach(viewRoleSelected => {
                this.mapQRCodeTypeDetail(QRCodeTypes.View);
                this.mapQRCodeRoleDetail(viewRoleSelected, QRCodeTypes.View);
            });
        }
    }

    private mapQRCodeRoleDetail(entity: any, type: QRCodeTypes) {
        let exists = this.qrCodeSetup.qrCodeRoleDetails.find(x => x.id == entity.id);
        if (!exists) {
            let qrCodeRoleDetail = new QRCodeRoleDetail();
            qrCodeRoleDetail.id = 0;
            qrCodeRoleDetail.qrCodeSetupId = this.qrCodeSetup.id ?? 0;
            qrCodeRoleDetail.roleId = entity.id ?? 0;
            qrCodeRoleDetail.type = QRCodeTypes[type];
            this.qrCodeSetup.qrCodeRoleDetails.push(qrCodeRoleDetail)
        }
    }

    private mapQRCodeTypeDetail(type: QRCodeTypes) {
        let exists = this.qrCodeSetup.qrCodeTypeDetails.find(
            x =>
                x.qrCodeSetupId == this.qrCodeSetup.id &&
                x.type == QRCodeTypes[type]
        );

        if (!exists) {
            let access = "";
            let qrCodeTypeDetail = new QRCodeTypeDetail();

            if (this.qrCodeSetup.roleAccessType == QRCodeRoleAccessType[QRCodeRoleAccessType.RoleBased]) {
                access = AccessTypes[AccessTypes.Private]
                let selectedQRCodeFormQuesRegister = [];
                if (type == QRCodeTypes.Populate_1)
                    selectedQRCodeFormQuesRegister = this.selectedPopulate1FormQuesRegister;
                else if (type == QRCodeTypes.Populate_2)
                    selectedQRCodeFormQuesRegister = this.selectedPopulate2FormQuesRegister;
                else if (type == QRCodeTypes.Populate_3)
                    selectedQRCodeFormQuesRegister = this.selectedPopulate3FormQuesRegister;
                else if (type == QRCodeTypes.Populate_4)
                    selectedQRCodeFormQuesRegister = this.selectedPopulate4FormQuesRegister;

                if (selectedQRCodeFormQuesRegister.length > 0 &&
                    (type == QRCodeTypes.Populate_1 ||
                        type == QRCodeTypes.Populate_2 ||
                        type == QRCodeTypes.Populate_3 ||
                        type == QRCodeTypes.Populate_4
                    )
                ) {
                    qrCodeTypeDetail.qrCodeQuestions = [];
                    //qr code selected questions
                    selectedQRCodeFormQuesRegister?.forEach(ele => {
                        let qrCodeQuestion = new QRCodeQuestion();
                        qrCodeQuestion.qrCodeTypeId = 0;
                        qrCodeQuestion.questionId = ele.id;
                        if (ele.type == "Checkbox") {
                            this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[type] + "_" + ele.id].value.forEach(chkvalue => {
                                qrCodeQuestion = new QRCodeQuestion();
                                qrCodeQuestion.qrCodeTypeId = 0;
                                qrCodeQuestion.questionId = ele.id;
                                qrCodeQuestion.value = chkvalue;
                                qrCodeTypeDetail.qrCodeQuestions.push(qrCodeQuestion);
                            });
                        }
                        else {
                            qrCodeQuestion.value = this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[type] + "_" + ele.id].value;
                            qrCodeTypeDetail.qrCodeQuestions.push(qrCodeQuestion);
                        }
                    });
                }
            }
            else {
                access = this.qrCodeSetupForm.controls["accessType"].value;
            }

            qrCodeTypeDetail.id = 0;
            qrCodeTypeDetail.qrCodeSetupId = this.qrCodeSetup.id ?? 0;
            qrCodeTypeDetail.accessType = access;
            qrCodeTypeDetail.type = QRCodeTypes[type];
            this.qrCodeSetup.qrCodeTypeDetails.push(qrCodeTypeDetail);
        }

    }

    private allAccordianOpenOnce() {
        if (this.qrCodeSetup.id > 0) {
            if (!this.createAccordionOpened) {
                if (this.qrCodeSetup.qrCodeRoleDetails.find(x => x.type == QRCodeTypes[QRCodeTypes.Create]))
                    this.onQRCodeCreateTypeTabOpen();
            }
            if (!this.updateAccordionOpened) {
                if (this.qrCodeSetup.qrCodeRoleDetails.find(x => x.type == QRCodeTypes[QRCodeTypes.Update]))
                    this.onQRCodeUpdateTypeTabOpen();
            }
            if (!this.populate1AccordionOpened) {
                this.populateQRCodeAllTypesAccordionOpenOnce(3);
            }
            if (!this.populate2AccordionOpened) {
                this.populateQRCodeAllTypesAccordionOpenOnce(4);
            }
            if (!this.populate3AccordionOpened) {
                this.populateQRCodeAllTypesAccordionOpenOnce(5)
            }
            if (!this.populate4AccordionOpened) {
                this.populateQRCodeAllTypesAccordionOpenOnce(6);
            }
            if (!this.viewAccordionOpened) {
                if (this.qrCodeSetup.qrCodeRoleDetails.find(x => x.type == QRCodeTypes[QRCodeTypes.View]))
                    this.onQRCodeViewTypeTabOpen();
            }
        }
    }

    private populateQRCodeAllTypesAccordionOpenOnce(populateSubType: number) {
        if (this.qrCodeSetup.qrCodeRoleDetails.find(x => x.type == QRCodeTypes[populateSubType]))
            this.onQRCodePopulateTypeTabOpen(populateSubType);
    }

    private isFormValid(): boolean {
        let errMsg: string;
        let isValid: boolean = true;
        if (this.qrCodeSetupForm.controls["name"].value == '') {
            errMsg = "QR Code Name is required."; this.asyncModalService.getModalResponse(errMsg); return false;
        }
        if (this.qrCodeSetupForm.controls["roleAccessType"].value == QRCodeRoleAccessType[QRCodeRoleAccessType.RoleBased]) {
            if (!(this.createRoleSelectedItems.length > 0 ||
                this.updateRoleSelectedItems.length > 0 ||
                this.populate1RoleSelectedItems.length > 0 ||
                this.populate2RoleSelectedItems.length > 0 ||
                this.populate3RoleSelectedItems.length > 0 ||
                this.populate4RoleSelectedItems.length > 0 ||
                this.viewRoleSelectedItems.length > 0)) {
                errMsg = "Please select Role for Role Based QR Code."; this.asyncModalService.getModalResponse(errMsg); return false;
            }
            else if (
                this.populate1RoleSelectedItems.length > 0 ||
                this.populate2RoleSelectedItems.length > 0 ||
                this.populate3RoleSelectedItems.length > 0 ||
                this.populate4RoleSelectedItems.length > 0
            ) {
                //if form questions are not selected for populate type qrcode
                if (
                    (this.selectedPopulate1FormQuesRegister.length <= 0 && this.populate1RoleSelectedItems.length > 0) ||
                    (this.selectedPopulate2FormQuesRegister.length <= 0 && this.populate2RoleSelectedItems.length > 0) ||
                    (this.selectedPopulate3FormQuesRegister.length <= 0 && this.populate3RoleSelectedItems.length > 0) ||
                    (this.selectedPopulate4FormQuesRegister.length <= 0 && this.populate4RoleSelectedItems.length > 0)
                ) {
                    if (this.selectedPopulate1FormQuesRegister.length <= 0 && this.populate1RoleSelectedItems.length > 0) {
                        errMsg = "<b>Populate 1</b>: Question is mandatory.";
                        this.asyncModalService.getModalResponse(errMsg);
                        isValid = false;
                        return;
                    }
                    else if (this.selectedPopulate2FormQuesRegister.length <= 0 && this.populate2RoleSelectedItems.length > 0) {
                        errMsg = "<b>Populate 2</b>: Question is mandatory.";
                        this.asyncModalService.getModalResponse(errMsg);
                        isValid = false;
                        return;
                    }
                    else if (this.selectedPopulate3FormQuesRegister.length <= 0 && this.populate3RoleSelectedItems.length > 0) {
                        errMsg = "<b>Populate 3</b>: Question is mandatory.";
                        this.asyncModalService.getModalResponse(errMsg);
                        isValid = false;
                        return;
                    }
                    else if (this.selectedPopulate4FormQuesRegister.length <= 0 && this.populate4RoleSelectedItems.length > 0) {
                        errMsg = "<b>Populate 4</b>: Question is mandatory.";
                        this.asyncModalService.getModalResponse(errMsg);
                        isValid = false;
                        return;
                    }
                }
                //if form questions are selected but not filled
                else {
                    this.selectedPopulate1FormQuesRegister.forEach(ele => {
                        if (ele.type != "Date" && (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[3] + "_" + ele.id].value == '' ||
                            (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[3] + "_" + ele.id].value).length == 0)) {
                            errMsg = "<b>Populate 1</b>: Fill out all question fields.";
                            this.asyncModalService.getModalResponse(errMsg);
                            isValid = false;
                            return;
                        }
                    });
                    this.selectedPopulate2FormQuesRegister.forEach(ele => {
                        if (ele.type != "Date" && (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[4] + "_" + ele.id].value == '' ||
                            (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[4] + "_" + ele.id].value).length == 0)) {
                            errMsg = "<b>Populate 2</b>: Fill out all question fields.";
                            this.asyncModalService.getModalResponse(errMsg);
                            isValid = false;
                            return;
                        }
                    });
                    this.selectedPopulate3FormQuesRegister.forEach(ele => {
                        if (ele.type != "Date" && (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[5] + "_" + ele.id].value == '' ||
                            (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[5] + "_" + ele.id].value).length == 0)) {
                            errMsg = "<b>Populate 3</b>: Fill out all question fields.";
                            this.asyncModalService.getModalResponse(errMsg);
                            isValid = false;
                            return;
                        }
                    });
                    this.selectedPopulate4FormQuesRegister.forEach(ele => {
                        if (ele.type != "Date" && (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[6] + "_" + ele.id].value == '' ||
                            (this.qrCodeSetupForm.controls["formQuestion_" + QRCodeTypes[6] + "_" + ele.id].value).length == 0)) {
                            errMsg = "<b>Populate 4</b>: Fill out all question fields.";
                            this.asyncModalService.getModalResponse(errMsg);
                            isValid = false;
                            return;
                        }
                    });
                }
            }
            //if roles are not selected in populate type qrcode
            else if (
                (this.selectedPopulate1FormQuesRegister.length > 0 && this.populate1RoleSelectedItems.length <= 0) ||
                (this.selectedPopulate2FormQuesRegister.length > 0 && this.populate2RoleSelectedItems.length <= 0) ||
                (this.selectedPopulate3FormQuesRegister.length > 0 && this.populate3RoleSelectedItems.length <= 0) ||
                (this.selectedPopulate4FormQuesRegister.length > 0 && this.populate4RoleSelectedItems.length <= 0)
            ) {
                if (this.selectedPopulate1FormQuesRegister.length > 0 && this.populate1RoleSelectedItems.length <= 0) {
                    errMsg = "<b>Populate 1</b>: Role is mandatory.";
                    this.asyncModalService.getModalResponse(errMsg);
                    isValid = false;
                    return;
                }
                else if (this.selectedPopulate2FormQuesRegister.length > 0 && this.populate2RoleSelectedItems.length <= 0) {
                    errMsg = "<b>Populate 2</b>: Role is mandatory.";
                    this.asyncModalService.getModalResponse(errMsg);
                    isValid = false;
                    return;
                }
                else if (this.selectedPopulate3FormQuesRegister.length > 0 && this.populate3RoleSelectedItems.length <= 0) {
                    errMsg = "<b>Populate 3</b>: Role is mandatory.";
                    this.asyncModalService.getModalResponse(errMsg);
                    isValid = false;
                    return;
                }
                else if (this.selectedPopulate4FormQuesRegister.length > 0 && this.populate4RoleSelectedItems.length <= 0) {
                    errMsg = "<b>Populate 4</b>: Role is mandatory.";
                    this.asyncModalService.getModalResponse(errMsg);
                    isValid = false;
                    return;
                }
            }
        }

        return isValid;
    }

    private setFormId() {
        //set formid
        let params = this.route.snapshot.params;
        if (params["id"]) {
            this.formId = +params["id"];
        }
    }

    checkDuplicateQrName() {
        this.inputSpinner.nativeElement.classList.add('pi-spinner');
        this.qrCodeService.getAll().subscribe(
            (data) => {
                if (data) {
                    this.inputSpinner.nativeElement.classList.remove('pi-spinner');
                    let qrCodeName = this.qrCodeSetupForm.controls["name"].value;
                    let exists = data.findIndex(x => x.id != this.qrCodeSetup.id && x.name?.replaceAll(' ', '') == qrCodeName?.replaceAll(' ', ''));
                    if (exists > -1) {
                        this.qrCodeSetupForm.controls["name"].setErrors({ duplicateNameExist: true });
                    }
                }
            },
            (err) => {
                this.asyncModalService.getModalResponse(err.error);
            }
        )
    }


    restrictSpecialChar(event) {
        var k;
        k = event.charCode;
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }
}
